export function lazyImport<T>(importFn: () => Promise<T>): () => Promise<T> {
  return () =>
    importFn().catch((error: unknown) => {
      const isChunkError =
        error instanceof TypeError &&
        error.message.includes("dynamically imported module");

      // Only auto-reload once per session to avoid infinite reload loops
      const reloadKey = "chunk-reload";
      const hasReloaded = sessionStorage.getItem(reloadKey);

      if (isChunkError && !hasReloaded) {
        sessionStorage.setItem(reloadKey, "true");
        window.location.reload();
        // Return a never-resolving promise to prevent React Router from rendering an error
        return new Promise<T>(() => {});
      }

      // Clear the flag if it was a different error or already reloaded
      sessionStorage.removeItem(reloadKey);
      throw error;
    });
}
